const Step = (props: any) => {
    return (
        <>
            {/* <div className={props.index === 0 ? "hidden" : "checkmark"}>
                <span className="step-out-line"></span>
            </div> */}
            <div className={props.index === 0 ? "hidden" : "check-mark"}>
                <div>
                    <img src="/img/checkout-steps-desc.png" alt="step" />
                </div>
            </div>
            <div className={props.styleClass}>{props.heading}</div>
        </>
    );
}

export default Step;